/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Thu May 05 2022
*  File : autoloader-dev.ts.ts
*******************************************/

import { config } from "../../../../cookist/com/lib/config/production.js";
import { CookistAutoloader } from "../../../../cookist/com/lib/modules/Autoloader.js";


const al = new CookistAutoloader(window, config, document.body);
window['getPushNotificationHelper'] = () => al.getPushHelper();
al.startSdkClient()

